import React, { useEffect, useState } from "react";
import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { handleRestrictionAnexoServico } from "../../../utils/handleRestrictionAnexoServico";
import CardCategoria from "../../../pages/ServicosAcolhimento/Anexos/CardCategoria";
import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import VisualizarAnexos from "../../../pages/ServicosAcolhimento/Anexos/VisualizarCategoria";
import { anexosFunc, criancaFunc } from "../../../../helpers/Funcionalidades";

export const Anexos = ({ data, dataSA }) => {
  const [categorias, setCategorias] = useState();
  const [selectedCategoriaId, setSelectedCategoriaId] = useState(-1);
  const [selectedCategoria, setSelectedCategoria] = useState();
  const { roleKeycloack, user } = useAuthProvider();

  useEffect(() => {
    if (data && dataSA) {
      let tempCategorias = [];
      if (dataSA.tipoServicoAcolhimento.regime === "SAF") {
        tempCategorias = data.filter(
          (categoria) =>
            categoria[1] !== "Oficio de Pessoa em Cumprimento de Pena" &&
            categoria[1] !== "Termo do Voluntariado"
        );
      } else {
        tempCategorias = [...data];
      }
      if (dataSA.naturezaServico === "publica") {
        tempCategorias = tempCategorias.filter(
          (categoria) =>
            categoria[1] !== "Estatuto da Entidade" &&
            categoria[1] !== "Registro no CMDCA" &&
            categoria[1] !== "Inscrição no CMAS"
        );
      }

      tempCategorias = handleRestrictionAnexoServico(
        tempCategorias,
        roleKeycloack
      );

      setCategorias(tempCategorias);
    }
  }, [data, dataSA, roleKeycloack]);

  return roleKeycloack &&
    (roleKeycloack.includes(anexosFunc.anexoServicoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(dataSA?.idPessoaJuridica))) ? (
    selectedCategoriaId === -1 ? (
      <Box display="block">
        <Box className="break-page">
          <Group
            bgColor="#DDEBEA"
            title="Anexos"
            mt="15px"
            py="12px"
            mtDivider="5px"
          >
            <Flex
              bgColor="#FFF"
              p="20px 20px 40px 20px"
              mt="15px"
              borderRadius="16px"
              flexDir="column"
            >
              <Grid
                mt="30px"
                templateColumns={{
                  base: "repeat(2, 1fr)",
                  md: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                }}
                gap="25px"
              >
                {categorias &&
                  categorias.map((categoria) => {
                    return (
                      <GridItem colSpan={1}>
                        <CardCategoria
                          key={categoria[0]}
                          categoria={categoria}
                          setCategoriaId={setSelectedCategoriaId}
                          setCategoria={setSelectedCategoria}
                        />
                      </GridItem>
                    );
                  })}
              </Grid>
            </Flex>
          </Group>
        </Box>
      </Box>
    ) : (
      <VisualizarAnexos
        categoria={selectedCategoria}
        setCategoriaId={setSelectedCategoriaId}
      />
    )
  ) : (
    <Box display="block">
      <Group
        bgColor="#DDEBEA"
        title="Voluntariado"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
